<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2021-08-19 17:06:02
 * @LastEditTime: 2021-08-24 20:06:22
 * @Description: 新增/编辑收款记录
 * @Param:
 * @FilePath: \JiYun_Mobile_test\src\views\salesTerminal\collectionRecord\addCollectionRecord.vue
 -->


<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonFormStyles addCollectionRecord">
            <van-nav-bar
                :title="text"
                left-text="收款记录"
                left-arrow
                @click-left="swiperright"
            >
            </van-nav-bar>
            <section>
                <van-form>
                    <van-field
                        is-link
                        readonly
                        required
                        label="合同编号"
                        v-model="formData.contract_number"
                        placeholder="请选择合同"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_gy_1.png')"
                        @click="selectContract"
                    ></van-field>
                    <van-field
                        readonly
                        label="客户名称"
                        v-model="formData.client_name"
                        placeholder="请选择合同"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_gy_8.png')"
                    ></van-field>
                    <van-field
                        readonly
                        label="工程名称"
                        v-model="formData.engineering_name"
                        placeholder="请选择合同"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_2.png')"
                    ></van-field>
                    <van-field
                        is-link
                        readonly
                        required
                        label="收款方式"
                        v-model="formData.proceeds_mode_name"
                        placeholder="请选择收款方式"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_gy_5.png')"
                        @click="proceedsModeShow = true"
                    ></van-field>
                    <van-field
                        readonly
                        label="承兑期限"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_gy_7.png')"
                    >
                        <template #input>
                            <van-radio-group v-model="formData.acceptance_period" direction="horizontal">
                                <van-radio name="1">
                                    6个月内
                                </van-radio>
                                <van-radio name="2">
                                    超6个月
                                </van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-field
                        label="支付银行"
                        v-model="formData.payment_bank"
                        placeholder="请输入"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_26.png')"
                    ></van-field>
                    <van-field
                        readonly
                        label="对方单位名称"
                        v-model="formData.corp_name"
                        placeholder="请选择合同"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_gy_8.png')"
                    ></van-field>
                    <van-field
                        readonly
                        label="我方单位名称"
                        v-model="formData.make_invoice_corp"
                        placeholder="请选择合同"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_gy_8.png')"
                    ></van-field>
                    <van-field
                        is-link
                        readonly
                        label="结算单号"
                        v-model="formData.settlement_number"
                        placeholder="请选择结算单"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_gy_1.png')"
                        @click="selectStatement"
                    ></van-field>
                    <van-field
                        readonly
                        label="对账日期"
                        v-model="formData.reconciliation_date"
                        placeholder="请选择结算单"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_gy_7.png')"
                    ></van-field>
                    <van-field
                        readonly
                        label="结算周期开始时间"
                        v-model="formData.settlement_start_time"
                        placeholder="请选择结算单"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_gy_7.png')"
                    ></van-field>
                    <van-field
                        readonly
                        label="结算周期结束时间"
                        v-model="formData.settlement_end_time"
                        placeholder="请选择结算单"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_gy_7.png')"
                    ></van-field>
                    <van-field
                        required
                        label="实收金额"
                        v-model="formData.official_receipt"
                        placeholder="请输入"
                        input-align="right"
                        right-icon="company"
                        :left-icon="require('@/assets/images/icons/icon_26.png')"
                    ></van-field>
                    <van-field
                        is-link
                        readonly
                        required
                        label="收款日期"
                        v-model="formData.receipt_date"
                        placeholder="请选择时间"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_gy_7.png')"
                        @click="selectTime('receipt_date')"
                    ></van-field>
                    <van-field
                        readonly
                        label="实收金额大写"
                        v-model="formData.official_receipt_chinese"
                        placeholder=""
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_26.png')"
                    ></van-field>
                    <van-field
                        readonly
                        label="期初按节点应收余额"
                        v-model="formData.Initial_receivables"
                        placeholder="请选择结算单"
                        input-align="right"
                        right-icon="company"
                        :left-icon="require('@/assets/images/icons/icon_26.png')"
                    ></van-field>
                    <van-field
                        readonly
                        label="本期按节点应收余额"
                        v-model="formData.loans_receivable"
                        placeholder="请选择结算单"
                        input-align="right"
                        right-icon="company"
                        :left-icon="require('@/assets/images/icons/icon_26.png')"
                    ></van-field>
                    <van-field
                        readonly
                        label="期末应收"
                        v-model="formData.ending_receivable"
                        placeholder="请选择结算单"
                        input-align="right"
                        right-icon="company"
                        :left-icon="require('@/assets/images/icons/icon_26.png')"
                    ></van-field>
                    <van-field
                        readonly
                        label="期末按节点应收余额"
                        v-model="formData.ending_balance_receivable"
                        placeholder="请选择结算单"
                        input-align="right"
                        right-icon="company"
                        :left-icon="require('@/assets/images/icons/icon_26.png')"
                    ></van-field>
                    <van-field
                        readonly
                        label="业务员"
                        v-model="formData.salesman_name"
                        placeholder="请选择合同"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_3.png')"
                    ></van-field>
                    <van-field
                        readonly
                        label="业务员电话"
                        v-model="formData.salesman_phone"
                        placeholder="请选择合同"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_4.png')"
                    ></van-field>
                    <van-field
                        readonly
                        label="服务员"
                        v-model="formData.waiter_name"
                        placeholder="请选择合同"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_3.png')"
                    ></van-field>
                    <van-field
                        is-link
                        readonly
                        required
                        label="场站"
                        v-model="formData.station_name"
                        placeholder="请选择场站"
                        input-align="right"
                        :left-icon="require('@/assets/images/icons/icon_gy_5.png')"
                        @click="stationShow = true"
                    ></van-field>
                </van-form>
                <van-popup v-model="proceedsModeShow" position="bottom">
                    <van-picker
                        title="选择收款方式"
                        show-toolbar
                        :columns="proceedsMode"
                        value-key="name"
                        @confirm="onConfirmProceedsMode"
                        @cancel="proceedsModeShow = false"
                    ></van-picker>
                </van-popup>
                <van-popup v-model="stationShow" position="bottom">
                    <van-picker
                        title="选择场站"
                        show-toolbar
                        :columns="stationData"
                        value-key="name"
                        @confirm="onConfirmStation"
                        @cancel="stationShow = false"
                    ></van-picker>
                </van-popup>
                <van-calendar
                    :min-date="minDate"
                    v-model="calendarShow"
                    @confirm="onConfirm"
                    color="#3495FB"
                ></van-calendar>
            </section>
            <div class="footer">
                <template v-if="[1,2].indexOf(formData.approval_status) === -1">
                    <van-button
                        plain
                        type="info"
                        color="#E81B1B"
                        native-type="submit"
                        @click="keepRecords"
                    >
                        保存
                    </van-button>
                    <van-button
                        type="info"
                        color="#E81B1B"
                        native-type="submit"
                        @click="submitRecords"
                        v-if="pkvalue != ''"
                    >
                        提交
                    </van-button>
                </template>
                <template v-else>
                    <van-button
                        plain
                        type="info"
                        color="#E81B1B"
                        native-type="submit"
                        @click="swiperright"
                    >
                        返回
                    </van-button>
                </template>
            </div>
        </div>
    </v-touch>
</template>
<script>
export default {
    name: 'add-collection-record',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (['/collectionRecord', '/recordList'].indexOf(to.path) > -1) {
            this.$store.commit('noKeepAlive', 'add-collection-record');
        }
        next();
    },
    props: {},
    data() {
        return {
            text: '',
            formData: {},
            openType: '',
            pkvalue: '',
            listIndex: null,
            parentName: '',
            // 收款方式
            proceedsMode: '',
            proceedsModeCode: '',
            proceedsModeShow: false,

            calendarShow: false,
            calendarType: '',
            // 时间控件最小时间
            minDate: new Date(2000, 0, 1),

            // 场站
            stationShow: false,
            stationData: [],
        };
    },
    computed: {},
    watch: {
        'formData.official_receipt'(newValue) {
            this.formData.official_receipt_chinese = this.ConvertChinese(Number(newValue));
        },
    },
    activated() {
        // 选择合同
        if (this.$route.params.contractData) {
            const contractData = this.$route.params.contractData;
            this.formData.contract_number = contractData.contract_number;
            this.formData.engineering_name = contractData.engineering_name;
            this.formData.engineering_number = contractData.engineering_number;
            this.formData.client_name = contractData.client_name;
            this.formData.salesman_name = contractData.salesman_name;
            this.formData.salesman_id = contractData.salesman_id;
            this.formData.salesman_phone = contractData.salesman_phone;
            this.formData.dept_id = contractData.dept_id;
            this.formData.dept_name = contractData.dept_name;
            this.formData.station_id = contractData.station_id;
            this.formData.station_name = contractData.station_name;
            this.formData.corp_name = contractData.corp_name;
            this.formData.bank_account = contractData.bank_account;
            this.formData.make_invoice_corp = contractData.make_invoice_corp;
            this.formData.waiter_id = contractData.waiter_id;
            this.formData.waiter_name = contractData.waiter_name;
            this.formData.waiter_phone = contractData.waiter_phone;
            this.formData.settlement_number = '';
        }
        // 选择结算单
        if (this.$route.params.selectList) {
            this.formData.settlement_number = this.$route.params.selectList.settlement_number;
            this.formData.reconciliation_date = this.$route.params.selectList.reconciliation_date;
            this.formData.settlement_start_time = this.$route.params.selectList.settlement_start_time;
            this.formData.settlement_end_time = this.$route.params.selectList.settlement_end_time;
            this.formData.Initial_receivables = this.$route.params.selectList.Initial_receivables;
            this.formData.loans_receivable = this.$route.params.selectList.loans_receivable;
            this.formData.ending_receivable = this.$route.params.selectList.ending_receivable;
            this.formData.ending_balance_receivable = this.$route.params.selectList.ending_balance_receivable;
            this.formData.receivables_decrease = this.$route.params.selectList.receivables_decrease;
        }
    },
    async created() {
        this.openType = this.$route.params.type;
        this.parentName = this.$route.params.parentName;
        if (this.openType === 'edit') {
            this.text = '编辑收款记录';
            this.formData = this.$route.params.row;
            this.pkvalue = this.formData.apid;
            this.listIndex = this.$route.params.listIndex;
        } else {
            this.text = '新增收款记录';
            this.formData = {
                settlement_number: '',
                contract_number: '',
                client_name: '',
                engineering_name: '',
                proceeds_mode_name: '',
                proceeds_mode: '',
                corp_name: '',
                bank_account: '',
                make_invoice_corp: '',
                make_invoice_account: '',
                reconciliation_date: '',
                settlement_start_time: '',
                settlement_end_time: '',
                official_receipt: null,
                receipt_date: '',
                Initial_receivables: null,
                loans_receivable: null,
                ending_receivable: null,
                ending_balance_receivable: null,
                salesman_name: '',
                salesman_id: '',
                salesman_phone: '',
                station_id: '',
                station_name: '',
                engineering_number: '',
                engineering_location: '',
                acceptance_period: null,
                remark: '',
                waiter_id: '',
                waiter_name: '',
                waiter_phone: '',
                official_receipt_chinese: '',
                payment_bank: '',
                dept_id: '',
                dept_name: '',
                receivables_decrease: null,
            };
        }
        this.stationData = await this.getStationData();
        this.proceedsMode = await this.getProceedsModeData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },

        // 选择合同
        selectContract() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'collectionSelectContract',
            });
        },

        // 选择结算单
        selectStatement() {
            if ((this.formData.contract_number || '') === '') {
                this.$toast('请先选择合同');
            } else {
                this.$router.isBack = 2;
                this.$router.push({
                    name: 'recordAssociation',
                    params: {
                        type: 'addCollectionRecord',
                        contract_number: this.formData.contract_number,
                    },
                });
            }
        },

        // 选择收款方式
        onConfirmProceedsMode(data) {
            this.formData.proceeds_mode_name = data.name;
            this.formData.proceeds_mode = data.code;
            this.proceedsModeShow = false;
        },

        // 选择场站
        onConfirmStation(data) {
            this.formData.station_id = data.station_id;
            this.formData.station_name = data.name;
            this.stationShow = false;
        },

        // 选择日期
        selectTime(type) {
            this.calendarType = type;
            this.calendarShow = true;
        },

        // 确认时间
        onConfirm(date) {
            this.calendarShow = false;
            this.formData[this.calendarType] = this.formatDate(date);
        },

        // 格式化时间
        formatDate(date) {
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        },

        // 保存记录
        async keepRecords() {
            let result = null;
            if (this.openType === 'edit') {
                result = await this.modifyRequest();
            } else {
                result = await this.addRequest();
                this.pkvalue = result;
            }
            if (result) {
                this.$toast.success('保存成功');
                this.$router.isBack = 1;
                this.$router.replace({
                    name: this.parentName,
                    params: {
                        editCallback: true,
                    },
                });
                this.$router.go(-1);
            }
        },

        // 提交记录
        async submitRecords() {
            if ((this.pkvalue || '') !== '') {
                const submit = await this.submitRequest();
                if (submit) {
                    this.$toast.success('提交成功');
                    this.$router.isBack = 1;
                    this.$router.replace({
                        name: this.parentName,
                        params: {
                            editCallback: true,
                            listIndex: this.listIndex,
                            row: this.formData,
                        },
                    });
                    this.$router.go(-1);
                }
            } else {
                this.$toast('请先保存');
            }
        },

        // 数字转中文
        ConvertChinese(n) {
            if (!n) {
                return null;
            }
            if (n === 0) {
                return '零';
            }
            if (!/^(\+|-)?(0|[1-9]\d*)(\.\d+)?$/.test(n)) {return '数据非法';}
            let unit = '仟佰拾亿仟佰拾万仟佰拾元角分';
            let str = '';
            n += '00';
            const a = parseFloat(n);
            if (a < 0) {
                n = n.substr(1);
            }
            const p = n.indexOf('.');
            if (p >= 0) {
                n = n.substring(0, p) + n.substr(p + 1, 2);
            }

            unit = unit.substr(unit.length - n.length);

            for (let i = 0; i < n.length; i++) {str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);}
            if (a > 0) {
                // eslint-disable-next-line max-len
                return str.replace(/零(仟|佰|拾|角)/g, '零').replace(/(零)+/g, '零').replace(/零(万|亿|元)/g, '$1').replace(/(亿)万|壹(拾)/g, '$1$2').replace(/^元零?|零分/g, '').replace(/元$/g, '元整');
            }
            // eslint-disable-next-line max-len
            return '负' + str.replace(/零(仟|佰|拾|角)/g, '零').replace(/(零)+/g, '零').replace(/零(万|亿|元)/g, '$1').replace(/(亿)万|壹(拾)/g, '$1$2').replace(/^元零?|零分/g, '').replace(/元$/g, '元整');
        },

        // 获取场站数据
        async getStationData() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationLs = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        name: stationNames[index],
                    };
                });
                return stationLs;
            }
            return [];
        },

        // 获取收款方式选项
        getProceedsModeData() {
            return this.$axios.$get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=601-FK0&type=6', { defEx: true });
        },

        // 新增请求
        addRequest() {
            return this.$axios.$post('/interfaceApi/sale/accounts/proceeds/add_accounts_proceeds', this.formData, { defEx: true });
        },

        // 修改请求
        modifyRequest() {
            return this.$axios.$post('/interfaceApi/sale/accounts/proceeds/modify_accounts_proceeds', this.formData, { defEx: true });
        },

        // 提交请求
        submitRequest() {
            return this.$axios.$post(`/interfaceApi/sale/accounts/proceeds/submit/${this.pkvalue}`, this.formData, { defEx: true });
        },
    },
};
</script>
<style lang="stylus" scoped>
.addCollectionRecord
    height 100%
    section
        height calc(100% - 83rpx)
        -webkit-overflow-scrolling touch
        overflow scroll
        >>>.van-cell
            border-bottom 1px solid #F0F0F0
            .van-field__label
                width 135rpx
            .van-field__control
                &::placeholder
                    color #E60000
            .van-cell__right-icon
                color #E60000
            .van-icon-company
                &:after
                    content '元'
                    color #666666
                    font-size 14px
                    vertical-align text-bottom
    .footer
        width 100%;
        display flex
        position absolute
        left 0
        bottom 0
        z-index 0
        .van-button
            flex 1
            border-radius 0
            font-size 16rpx
</style>
